import { createSvgIcon } from '@mui/material';

const InternationalIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_745)">
      <path
        d="M9.3 3.50001C10.15 3.24001 11.04 3.10001 11.98 3.10001C16.95 3.10001 20.98 7.13001 20.98 12.1C20.98 17.07 16.95 21.1 11.98 21.1C7.01001 21.1 2.98 17.07 2.98 12.1C2.98 11.21 3.11 10.35 3.35 9.54001M10.52 9.10001H20.38M3.58 15.1H20.38M8.95 10.83C8.69 14.37 9.53 17.97 11.48 21.1M11.48 3.10001C11.13 3.66001 10.82 4.23001 10.54 4.81001M12.48 3.10001C15.92 8.61001 15.92 15.59 12.48 21.1M8.4 6.90001C8.4 7.7671 7.69709 8.47001 6.83 8.47001C5.96292 8.47001 5.26001 7.7671 5.26001 6.90001C5.26001 6.03292 5.96292 5.33001 6.83 5.33001C7.69709 5.33001 8.4 6.03292 8.4 6.90001ZM9.8 9.87001L7.57 12.1C7.16 12.51 6.50001 12.51 6.09001 12.1L3.86 9.87001C2.22 8.23001 2.22 5.57001 3.86 3.93001C5.5 2.29001 8.16 2.29001 9.8 3.93001C11.44 5.57001 11.44 8.23001 9.8 9.87001Z"
        stroke="#597180"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_745">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'InternationalIcon',
);

export default InternationalIcon;
